import http from './request'
import { STORAGE } from './constants'
import router from '.././router'
const _import = require('../router/_import_' + process.env.NODE_ENV)
// let STORAGE = require('./constants')

/**
 * 从当前session storage中获取user对象
 * @returns {any}
 */
export function getLoginUser () {
  let userInSession = sessionStorage.getItem(STORAGE.LOGIN_USER)
  if (userInSession !== null) return JSON.parse(userInSession)
  return null
}

/**
 * 设置用户到session storage中
 */
export function setLoginUser (user) {
  sessionStorage.setItem(STORAGE.LOGIN_USER, JSON.stringify(user || '{}'))
}

/**
 * 清除用户信息
 */
export function clearLoginUser () {
  sessionStorage.removeItem(STORAGE.LOGIN_USER)
}

export function getToken() {
  let loginUser = getLoginUser()
  if (loginUser != null && loginUser !== '' && loginUser !== {} && loginUser !== undefined) {
      return loginUser.token
  } else {
    return null
  }
}

/**
 * 网络请求
 * @param url
 * @param method
 * @param data
 * @param json(default) or form
 * @return {*}
 */
export function doHttp (url, method, data, type) {
  let obj = {
    url: http.adornUrl(url),
    method
  }

  if (method === 'get' || method === 'GET') {
    obj.params = http.adornParams(data)
  } else if (method === 'post' || method === 'POST') {
    obj.data = http.adornData(data, type)
  }

  return http(obj)
}

/**
 * 格式化日期
 * @param date
 * @param fmt
 * @returns {*}
 */
export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
    }
  }
  return fmt
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}

export function formatDecimal (num) {
  if (num == null) return 0
  let reg = /\d{1,3}(?=(\d{3})+$)/g
  return (num + '').replace(reg, '$&,')
}



// WEBPACK FOOTER //
// ./src/util/common.js